import React, { useContext } from 'react';
import { FormsContext } from 'pages/Forms/context/FormsContext';
import QuestionTitle from './QuestionTitle';
import { HStack } from '@televet/kibble-ui';
import { Button } from '@televet/kibble-ui';
import { FormQuestionType } from '@televet/shared-types';

interface IQuestionHeaderProps {
  index: number;
  questionType: FormQuestionType;
  lastIndex: number;
}

const QuestionHeader = ({ index, questionType, lastIndex }: IQuestionHeaderProps): JSX.Element => {
  const { dispatch, formTemplateType } = useContext(FormsContext);

  const onMoveUp = (): void => {
    dispatch({ type: 'MOVE_QUESTION_AT_INDEX_UP', payload: { questionIndex: index } });
  };

  const onMoveDown = (): void => {
    dispatch({ type: 'MOVE_QUESTION_AT_INDEX_DOWN', payload: { questionIndex: index } });
  };

  const onRemove = (): void => {
    dispatch({ type: 'REMOVE_QUESTION_AT_INDEX', payload: { index, formTemplateType } });
  };

  return (
    <HStack justify="space-between" paddingBottom="1">
      <QuestionTitle index={index} questionType={questionType} />
      <HStack>
        {index !== 0 && <Button variant="secondary" size="xs" iconName="arrowUp" onClick={onMoveUp} />}
        {index !== lastIndex && <Button variant="secondary" size="xs" iconName="arrowDown" onClick={onMoveDown} />}
        <Button variant="secondary" size="xs" iconName="trashcan" onClick={onRemove} />
      </HStack>
    </HStack>
  );
};

export default QuestionHeader;
